import React, { useState, useEffect } from 'react';
import '../../styles/landing/journey.css';
import sampleImage from '../../assets/img/sample_collection_AI.jpg';
import spectrometryImage from '../../assets/img/mass_spectrometer_AI.jpg';
import dataImage from '../../assets/img/data_nodes_AI.webp';
import patientImage from '../../assets/img/patient_chart_AI.jpg';
import { ReactComponent as TestTubeIcon } from '../../assets/svg/test-tube-svg.svg';
import { ReactComponent as StethoscopeIcon } from '../../assets/svg/stethoscope-svg.svg';
import { ReactComponent as DataIcon } from '../../assets/svg/data-svg.svg';
import { ReactComponent as MicroscopeIcon } from '../../assets/svg/analyze-svg.svg';
import {ReactComponent as RightArrow} from '../../assets/svg/right-arrow-svg.svg';

const Journey = () => {
	const data = [
		{ 
			id: 'SAMPLE COLLECTION', 
			text: 'The journey begins with collecting biological samples, such as tumor tissues or blood plasma, from patients. These samples contain crucial proteins that provide insights into the disease.', 
			icon: <TestTubeIcon />,
			background: sampleImage
		},
		{ 
			id: 'MASS SPECTOMETRY', 
			text: 'Advanced mass spectrometry tools measure and identify proteins, generating highly detailed data about their structure, abundance, and modifications. This step is vital for understanding cancer’s molecular mechanisms.', 
			icon: <MicroscopeIcon />,
			background: spectrometryImage
		},
		{ 
			id: 'DATA INTEGRATION', 
			text: 'Proteomics data is integrated with genomics, imaging, and clinical records to create a comprehensive molecular profile. This combination helps refine diagnoses and personalize therapies.', 
			icon: <DataIcon />,
			background: dataImage
		},
		{ 
			id: 'CLINICAL INSIGHTS', 
			text: 'With proteomics data, clinicians identify biomarkers and tailor treatments to the patient’s unique molecular profile, improving outcomes and reducing trial-and-error approaches.', 
			icon: <StethoscopeIcon />,
			background: patientImage
		},
	];

	const [selectedIndex, setSelectedIndex] = useState(0);

	// handle key press for navigation
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === 'ArrowLeft') {
				handlePrevious();
			} else if (e.key === 'ArrowRight') {
				handleNext();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, []);

	const handlePrevious = () => {
		setSelectedIndex((prev) => (prev === 0 ? data.length - 1 : prev - 1));
	};

	const handleNext = () => {
		setSelectedIndex((prev) => (prev === data.length - 1 ? 0 : prev + 1));
	};

	const progressPercentage = ((selectedIndex + 1) / data.length) * 100;

	

	return (
		<div 
			className="landing-journey" 
			style={{ background: `url(${data[selectedIndex].background}) no-repeat center center/cover` }}
			tabIndex="0"
		>
			<h2 className="landing-journey-title">Proteomics in Action: A Journey from Sample to Solution</h2>
			<section 
				className={`landing-journey-diagram`}
			>
				<div className="cards-container">
					{data.map((card, index) => {
						const isActive = index === selectedIndex;
						return (
							<div 
								key={card.id} 
								className={`landing-journey-diagram-card ${card.id.split(' ')[0]} ${isActive ? 'active' : ''}`}
							>
								{card.icon}
								<h3>{card.id}</h3>
							</div>
						);
					})}
				</div>

				<div className="navigation-container">
					<button className="carousel-arrow left" onClick={handlePrevious} aria-label="Previous slide">
						<RightArrow />
					</button>
					<button className="carousel-arrow" onClick={handleNext} aria-label="Next slide">
						<RightArrow />
					</button>
					<div className="progress-bar">
						<div 
							className="progress-bar-fill"
							style={{ width: `${progressPercentage}%` }}
						></div>
					</div>
					<h3>Step {selectedIndex + 1} of {data.length}</h3>
				</div>
			</section>

			<div className="landing-journey-info">
				<h2>{data[selectedIndex].id}</h2>
				<h3>{data[selectedIndex].text}</h3>
			</div>
		</div>
	);
};

export default Journey;
